// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Base Styles ========== */
:root {
  /* Color Variables */
  --color-primary: #d85200;
  --color-primary-light: #fce3d3;
  --color-primary-dark: #a34103;
  --color-secondary: #d82800;
  --color-secondary-light: #ef8d72;
  --color-secondary-dark: #a8270b;
  --color-accent: #fbeee5;
  --color-accent-light: #fab98b;
  --color-accent-dark: #ed763a;
  --color-warning: #f59e0b;
  --color-danger: #ef4444;
  --color-success: #10b981;
  --color-info: #f66a3b;

  /* Neutral Colors */
  --color-text-primary: #3b241e;
  --color-text-secondary: #8b6f64;
  --color-text-tertiary: #b89e94;
  --color-bg-primary: #ffffff;
  --color-bg-secondary: #fcf9f8;
  --color-bg-tertiary: #f9f4f1;
  --color-border: #f0e7e2;

  /* Gradients */
  --gradient-primary: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);
  --gradient-secondary: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-secondary-light) 100%);
  --gradient-accent: linear-gradient(135deg, var(--color-primary-light) 0%, var(--color-accent) 100%);
  --gradient-success: linear-gradient(135deg, var(--color-success) 0%, #34d399 100%);
  --gradient-warning: linear-gradient(135deg, var(--color-warning) 0%, #fbbf24 100%);
  --gradient-danger: linear-gradient(135deg, var(--color-danger) 0%, #f87171 100%);
  --gradient-header: linear-gradient(135deg, #ffffff 0%, #fff3ee 100%);

  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.15);
  --shadow-card: 0 0 20px rgba(0, 0, 0, 0.08);
  --shadow-card-hover: 0 10px 30px rgba(0, 0, 0, 0.12);

  /* Border Radius */
  --radius-sm: 0.25rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-2xl: 1.5rem;
  --radius-full: 9999px;

  /* Transitions */
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;

  /* Typography */
  --font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  --font-size-xs: 0.75rem;
  --font-size-sm: 0.875rem;
  --font-size-md: 1rem;
  --font-size-lg: 1.125rem;
  --font-size-xl: 1.25rem;
  --font-size-2xl: 1.5rem;
  --font-size-3xl: 1.875rem;
  --font-size-4xl: 2.25rem;
  --font-size-5xl: 3rem;

  /* Spacing */
  --spacing-1: 0.25rem;
  --spacing-2: 0.5rem;
  --spacing-3: 0.75rem;
  --spacing-4: 1rem;
  --spacing-5: 1.25rem;
  --spacing-6: 1.5rem;
  --spacing-8: 2rem;
  --spacing-10: 2.5rem;
  --spacing-12: 3rem;
  --spacing-16: 4rem;
  --spacing-20: 5rem;

  /* Z-index */
  --z-0: 0;
  --z-10: 10;
  --z-20: 20;
  --z-30: 30;
  --z-40: 40;
  --z-50: 50;
  --z-auto: auto;
}

/* Global Reset */
*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-family);
  color: var(--color-text-primary);
  background-color: var(--color-bg-secondary);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ========== Main Container ========== */
.office-office-wrapper {
  min-height: 100vh;
  width: 100%;
}

/* ========== Enhanced Header Section ========== */
.office-office-header {
  background: var(--gradient-header);
  padding: 15px 20px;
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-lg);
}

.office-office-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.office-animated-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 20s infinite ease-in-out;
}

.office-shape-1 {
  width: 200px;
  height: 200px;
  top: -100px;
  left: -50px;
  animation-delay: 0s;
}

.office-shape-2 {
  width: 150px;
  height: 150px;
  bottom: -75px;
  right: 10%;
  animation-delay: -5s;
}

.office-shape-3 {
  width: 100px;
  height: 100px;
  top: 30%;
  right: 20%;
  animation-delay: -10s;
}

.office-shape-4 {
  width: 120px;
  height: 120px;
  bottom: 20%;
  left: 15%;
  animation-delay: -15s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg) scale(1);
    opacity: 0.4;
  }
  25% {
    transform: translateY(-20px) rotate(90deg) scale(1.1);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-10px) rotate(180deg) scale(0.9);
    opacity: 0.8;
  }
  75% {
    transform: translateY(-30px) rotate(270deg) scale(1.05);
    opacity: 0.5;
  }
}

.office-office-header-content {
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  text-align: center;
}

.office-office-title {
  font-size: 28px;
  font-weight: 800;
  color: rgb(196, 72, 1);
  margin-bottom: var(--spacing-2);
  letter-spacing: -0.025em;
  background: linear-gradient(to right, #dc3610, #dd3d17);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

/* ========== Office Controls ========== */
.office-office-controls {
  max-width: 1400px;
  margin: 0 auto var(--spacing-8);
  padding: 0 var(--spacing-4);
  margin-top: 30px;
}

.office-search-wrapper {
  position: relative;
  margin-bottom: var(--spacing-6);
}

.office-office-search-input {
  width: 100%;
  padding: var(--spacing-4) var(--spacing-4) var(--spacing-4) var(--spacing-12);
  border-radius: var(--radius-full);
  border: 1px solid var(--color-border);
  font-size: var(--font-size-md);
  background: var(--color-bg-primary);
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-normal);
}

.office-office-search-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.office-search-icon {
  position: absolute;
  left: var(--spacing-4);
  top: 50%;
  transform: translateY(-50%);
  font-size: var(--font-size-lg);
  color: var(--color-text-tertiary);
}

.office-view-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--spacing-4);
}

.office-view-toggle {
  display: flex;
  background: var(--color-bg-primary);
  border-radius: var(--radius-lg);
  padding: var(--spacing-1);
  box-shadow: var(--shadow-sm);
}

.office-view-toggle-btn {
  padding: var(--spacing-2) var(--spacing-4);
  border: none;
  background: transparent;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  color: var(--color-text-secondary);
}

.office-view-toggle-btn.office-active {
  background:var(--color-primary);
  color: white;
  box-shadow: var(--shadow-sm);
}

.office-view-icon {
  font-size: var(--font-size-lg);
}

.office-filter-and-sort {
  display: flex;
  gap: var(--spacing-3);
  align-items: center;
  flex-wrap: wrap;
}

.office-add-expense-btn, .office-show-all-btn {
  background: var(--gradient-secondary);
  color: white;
  padding: var(--spacing-2) var(--spacing-5);
  border-radius: var(--radius-md);
  border: none;
  font-size: var(--font-size-sm);
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  transition: all var(--transition-normal);
  box-shadow: var(--shadow-sm);
}

.office-add-expense-btn:hover, .office-show-all-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.office-btn-icon {
  font-size: var(--font-size-lg);
  transition: transform var(--transition-normal);
}

.office-add-expense-btn:hover .office-btn-icon {
  transform: rotate(90deg);
}

.office-show-all-btn:hover .office-btn-icon {
  transform: rotate(360deg);
}

/* ========== Error State ========== */
.office-office-error {
  max-width: 1400px;
  margin: 0 auto var(--spacing-8);
  padding: var(--spacing-4);
  background: linear-gradient(135deg, #fff5f5, #fed7d7);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  box-shadow: var(--shadow-sm);
  animation: slideIn var(--transition-normal);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.office-error-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  background: var(--color-danger);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-xl);
  font-weight: bold;
}

.office-error-content h4 {
  margin: 0 0 var(--spacing-1);
  color: var(--color-danger);
  font-size: var(--font-size-lg);
}

.office-error-content p {
  margin: 0;
  color: #742a2a;
}

/* ========== Loading State ========== */
.office-office-loading {
  max-width: 1400px;
  margin: var(--spacing-16) auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-6);
}

.office-loading-animation {
  display: flex;
  gap: var(--spacing-2);
}

.office-loading-circle {
  width: 16px;
  height: 16px;
  border-radius: var(--radius-full);
  animation: bounce 1.4s infinite ease-in-out both;
}

.office-loading-circle:nth-child(1) {
  background-color: var(--color-primary);
  animation-delay: -0.32s;
}

.office-loading-circle:nth-child(2) {
  background-color: var(--color-secondary);
  animation-delay: -0.16s;
}

.office-loading-circle:nth-child(3) {
  background-color: var(--color-accent);
  animation-delay: 0s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.office-office-loading p {
  color: var(--color-text-secondary);
  font-size: var(--font-size-lg);
}

/* ========== Card View ========== */
.office-stationary-card-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--spacing-6);
  padding: 0 var(--spacing-4);
  max-width: 1400px;
  margin: 0 auto;
}

.office-stationary-card {
  background: var(--color-bg-primary);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-card);
  transition: all var(--transition-normal);
  position: relative;
}

.office-stationary-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background: var(--gradient-primary);
}

.office-stationary-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-card-hover);
}

.office-stationary-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-4) var(--spacing-6);
  background: var(--color-bg-tertiary);
  border-bottom: 1px solid var(--color-border);
}

.office-stationary-price {
  font-weight: 700;
  color: var(--color-primary);
  font-size: var(--font-size-md);
}

.office-stationary-card-body {
  padding: var(--spacing-6);
}

.office-stationary-info {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.office-info-item {
  display: flex;
  justify-content: space-between;
}

.office-info-label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  font-weight: 500;
}

.office-info-value {
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  font-weight: 500;
}

.office-stationary-card-actions {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: var(--color-border);
}

.office-card-icon {
  font-size: var(--font-size-lg);
}

/* ========== Table View ========== */
.office-expense-table-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--spacing-4);
  overflow-x: auto;
}

.office-expense-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: var(--color-bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
  overflow: hidden;
}

.office-expense-table th, .office-expense-table td {
  padding: var(--spacing-4);
  text-align: left;
  border-bottom: 1px solid var(--color-border);
}

.office-expense-table th {
  background: var(--color-bg-tertiary);
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: background var(--transition-fast);
}

.office-expense-table th:hover {
  background: var(--color-bg-secondary);
}

.office-expense-table tr:last-child td {
  border-bottom: none;
}

.office-expense-table td {
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
}

.office-expense-table tr:hover {
  background: var(--color-bg-tertiary);
}

.office-amount-cell {
  font-weight: 600;
  color: var(--color-primary);
}

.office-action-cell {
  display: flex;
  gap: var(--spacing-2);
  align-items: center;
}

.office-sort-icon {
  font-size: var(--font-size-xs);
  margin-left: var(--spacing-1);
}

.office-action-btn {
  padding: var(--spacing-2) var(--spacing-4);
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
}
.office-edit-btn {
   
    border: 2px solid rgb(255, 174, 0);
    color: #ff8600;
    background: white;
}

.office-delete-btn {
  background: var(--gradient-danger);
  color: white;
}

.office-print-btn {
  background: white;
  color: rgb(0, 0, 0);
  border: 2px solid black;
}

.office-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* ========== Pagination ========== */
.office-pagination-container {
  display: flex;
  justify-content: center;
  margin: var(--spacing-6) 0;
}

.office-pagination {
  display: flex;
  gap: var(--spacing-2);
}

.office-pagination-btn {
  padding: var(--spacing-2) var(--spacing-4);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.office-pagination-btn:hover:not(:disabled) {
  background: var(--color-bg-tertiary);
  border-color: var(--color-text-tertiary);
}

.office-pagination-btn.office-active {
  background:grey;
  color: white;
  border-color: transparent;
}

.office-pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ========== No Data State ========== */
.office-office-no-data {
  text-align: center;
  padding: var(--spacing-16) var(--spacing-4);
  background: var(--color-bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  max-width: 1400px;
  margin: 0 auto;
}

.office-no-data-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-4);
}

.office-no-data-icon {
  font-size: var(--font-size-5xl);
  color: var(--color-text-tertiary);
  margin-bottom: var(--spacing-4);
  animation: float 3s ease-in-out infinite;
}

.office-no-data-content h3 {
  color: var(--color-text-primary);
  font-size: var(--font-size-2xl);
  margin-bottom: var(--spacing-2);
}

.office-no-data-content p {
  color: var(--color-text-secondary);
  font-size: var(--font-size-md);
  margin-bottom: var(--spacing-6);
}

.office-add-expense-btn-small {
  background: var(--gradient-secondary);
  color: white;
  padding: var(--spacing-2) var(--spacing-4);
  border-radius: var(--radius-md);
  border: none;
  font-size: var(--font-size-sm);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.office-add-expense-btn-small:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
}

/* ========== Add/Edit Form ========== */
.office-addofficeExpenseform-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.office-addofficeExpenseform-container {
  background-color: #fff;
  padding: 2.5rem;
  border-radius: 16px;
  width: 90%;
  max-width: 520px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  position: relative;
}

.office-addofficeExpenseform-close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-size: 18px;
  cursor: pointer;
}

.office-addofficeExpenseform-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin-bottom: 1.5rem;
}

.office-addofficeExpenseform-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.office-addofficeExpenseform-field {
  display: flex;
  flex-direction: column;
}

.office-addofficeExpenseform-input {
  padding: 0.75rem 1rem;
  border: 2px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.office-addofficeExpenseform-input:focus {
  border-color: #ff5e00;
  box-shadow: 0 0 0 3px rgba(255, 115, 0, 0.2);
  outline: none;
}

.office-addofficeExpenseform-submit-button {
  background-color: #ff5100;
  color: #fff;
  border: none;
  padding: 0.9rem;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 1rem;
}

.office-addofficeExpenseform-submit-button:hover {
  background-color: #b33900;
}

/* ========== Date Range Wrapper ========== */
.office-date-range-wrapper {
  display: flex;
  gap: var(--spacing-4);
  margin-bottom: var(--spacing-6);
  flex-wrap: wrap;
}

.office-date-input {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 150px;
}

.office-date-label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-2);
  font-weight: 500;
}

.office-office-search-input[type="date"] {
  padding: var(--spacing-3) var(--spacing-4);
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

/* ========== Total Amount Display ========== */
.office-total-amount {
  margin-bottom: var(--spacing-6);
  text-align: center;
}

.office-total-amount h3 {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--color-primary);
  background: var(--color-bg-primary);
  padding: var(--spacing-2) var(--spacing-4);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
}

/* ========== Responsive Adjustments ========== */
@media (max-width: 1200px) {
  .office-office-title {
    font-size: var(--font-size-3xl);
  }
}

@media (max-width: 992px) {
  .office-view-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .office-view-toggle {
    justify-content: center;
  }

  .office-filter-and-sort {
    justify-content: space-between;
  }
}

@media (max-width: 768px) {
  .office-office-title {
    font-size: var(--font-size-2xl);
  }

  .office-stationary-card-container {
    grid-template-columns: 1fr;
  }

  .office-date-range-wrapper {
    flex-direction: column;
  }

  .office-date-input {
    min-width: 100%;
  }

  .office-expense-table th, .office-expense-table td {
    padding: var(--spacing-3);
    font-size: var(--font-size-xs);
  }

  .office-action-btn {
    padding: var(--spacing-1) var(--spacing-2);
    font-size: var(--font-size-xs);
  }
}

@media (max-width: 576px) {
  .office-office-header {
    padding: var(--spacing-8) var(--spacing-4);
  }

  .office-filter-and-sort {
    flex-direction: column;
    gap: var(--spacing-2);
  }

  .office-add-expense-btn, .office-show-all-btn {
    width: 100%;
    justify-content: center;
  }

  .office-stationary-card-actions {
    grid-template-columns: repeat(2, 1fr);
  }

  .office-addofficeExpenseform-container {
    padding: 1.5rem;
  }

  .office-addofficeExpenseform-title {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/office/office.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;;EAErB,mBAAmB;EACnB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;;EAEvB,cAAc;EACd,qGAAqG;EACrG,2GAA2G;EAC3G,mGAAmG;EACnG,kFAAkF;EAClF,kFAAkF;EAClF,gFAAgF;EAChF,oEAAoE;;EAEpE,YAAY;EACZ,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,oDAAoD;;EAEpD,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;;EAErB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;;EAE5B,eAAe;EACf,mJAAmJ;EACnJ,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;;EAErB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,2CAA2C;EAC3C,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE;IACE,8CAA8C;IAC9C,YAAY;EACd;EACA;IACE,qDAAqD;IACrD,YAAY;EACd;EACA;IACE,sDAAsD;IACtD,YAAY;EACd;EACA;IACE,uDAAuD;IACvD,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,wBAAwB;EACxB,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,6EAA6E;EAC7E,iCAAiC;EACjC,qCAAqC;EACrC,8BAA8B;EAC9B,mCAAmC;EACnC,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,0CAA0C;EAC1C,+BAA+B;EAC/B,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,qDAAqD;EACrD,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,4DAA4D;EAC5D,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;AACA;;IAEI,kCAAkC;IAClC,cAAc;IACd,iBAAiB;AACrB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,0CAA0C;EAC1C,+BAA+B;EAC/B,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,iDAAiD;AACjD;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,0CAA0C;IAC1C,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ========== Base Styles ========== */\n:root {\n  /* Color Variables */\n  --color-primary: #d85200;\n  --color-primary-light: #fce3d3;\n  --color-primary-dark: #a34103;\n  --color-secondary: #d82800;\n  --color-secondary-light: #ef8d72;\n  --color-secondary-dark: #a8270b;\n  --color-accent: #fbeee5;\n  --color-accent-light: #fab98b;\n  --color-accent-dark: #ed763a;\n  --color-warning: #f59e0b;\n  --color-danger: #ef4444;\n  --color-success: #10b981;\n  --color-info: #f66a3b;\n\n  /* Neutral Colors */\n  --color-text-primary: #3b241e;\n  --color-text-secondary: #8b6f64;\n  --color-text-tertiary: #b89e94;\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: #fcf9f8;\n  --color-bg-tertiary: #f9f4f1;\n  --color-border: #f0e7e2;\n\n  /* Gradients */\n  --gradient-primary: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);\n  --gradient-secondary: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-secondary-light) 100%);\n  --gradient-accent: linear-gradient(135deg, var(--color-primary-light) 0%, var(--color-accent) 100%);\n  --gradient-success: linear-gradient(135deg, var(--color-success) 0%, #34d399 100%);\n  --gradient-warning: linear-gradient(135deg, var(--color-warning) 0%, #fbbf24 100%);\n  --gradient-danger: linear-gradient(135deg, var(--color-danger) 0%, #f87171 100%);\n  --gradient-header: linear-gradient(135deg, #ffffff 0%, #fff3ee 100%);\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.15);\n  --shadow-card: 0 0 20px rgba(0, 0, 0, 0.08);\n  --shadow-card-hover: 0 10px 30px rgba(0, 0, 0, 0.12);\n\n  /* Border Radius */\n  --radius-sm: 0.25rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-2xl: 1.5rem;\n  --radius-full: 9999px;\n\n  /* Transitions */\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n\n  /* Typography */\n  --font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  --font-size-xs: 0.75rem;\n  --font-size-sm: 0.875rem;\n  --font-size-md: 1rem;\n  --font-size-lg: 1.125rem;\n  --font-size-xl: 1.25rem;\n  --font-size-2xl: 1.5rem;\n  --font-size-3xl: 1.875rem;\n  --font-size-4xl: 2.25rem;\n  --font-size-5xl: 3rem;\n\n  /* Spacing */\n  --spacing-1: 0.25rem;\n  --spacing-2: 0.5rem;\n  --spacing-3: 0.75rem;\n  --spacing-4: 1rem;\n  --spacing-5: 1.25rem;\n  --spacing-6: 1.5rem;\n  --spacing-8: 2rem;\n  --spacing-10: 2.5rem;\n  --spacing-12: 3rem;\n  --spacing-16: 4rem;\n  --spacing-20: 5rem;\n\n  /* Z-index */\n  --z-0: 0;\n  --z-10: 10;\n  --z-20: 20;\n  --z-30: 30;\n  --z-40: 40;\n  --z-50: 50;\n  --z-auto: auto;\n}\n\n/* Global Reset */\n*, *::before, *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: var(--font-family);\n  color: var(--color-text-primary);\n  background-color: var(--color-bg-secondary);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* ========== Main Container ========== */\n.office-office-wrapper {\n  min-height: 100vh;\n  width: 100%;\n}\n\n/* ========== Enhanced Header Section ========== */\n.office-office-header {\n  background: var(--gradient-header);\n  padding: 15px 20px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n}\n\n.office-office-header-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n}\n\n.office-animated-shape {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  animation: float 20s infinite ease-in-out;\n}\n\n.office-shape-1 {\n  width: 200px;\n  height: 200px;\n  top: -100px;\n  left: -50px;\n  animation-delay: 0s;\n}\n\n.office-shape-2 {\n  width: 150px;\n  height: 150px;\n  bottom: -75px;\n  right: 10%;\n  animation-delay: -5s;\n}\n\n.office-shape-3 {\n  width: 100px;\n  height: 100px;\n  top: 30%;\n  right: 20%;\n  animation-delay: -10s;\n}\n\n.office-shape-4 {\n  width: 120px;\n  height: 120px;\n  bottom: 20%;\n  left: 15%;\n  animation-delay: -15s;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg) scale(1);\n    opacity: 0.4;\n  }\n  25% {\n    transform: translateY(-20px) rotate(90deg) scale(1.1);\n    opacity: 0.6;\n  }\n  50% {\n    transform: translateY(-10px) rotate(180deg) scale(0.9);\n    opacity: 0.8;\n  }\n  75% {\n    transform: translateY(-30px) rotate(270deg) scale(1.05);\n    opacity: 0.5;\n  }\n}\n\n.office-office-header-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n  text-align: center;\n}\n\n.office-office-title {\n  font-size: 28px;\n  font-weight: 800;\n  color: rgb(196, 72, 1);\n  margin-bottom: var(--spacing-2);\n  letter-spacing: -0.025em;\n  background: linear-gradient(to right, #dc3610, #dd3d17);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-fill-color: transparent;\n}\n\n/* ========== Office Controls ========== */\n.office-office-controls {\n  max-width: 1400px;\n  margin: 0 auto var(--spacing-8);\n  padding: 0 var(--spacing-4);\n  margin-top: 30px;\n}\n\n.office-search-wrapper {\n  position: relative;\n  margin-bottom: var(--spacing-6);\n}\n\n.office-office-search-input {\n  width: 100%;\n  padding: var(--spacing-4) var(--spacing-4) var(--spacing-4) var(--spacing-12);\n  border-radius: var(--radius-full);\n  border: 1px solid var(--color-border);\n  font-size: var(--font-size-md);\n  background: var(--color-bg-primary);\n  box-shadow: var(--shadow-sm);\n  transition: all var(--transition-normal);\n}\n\n.office-office-search-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n\n.office-search-icon {\n  position: absolute;\n  left: var(--spacing-4);\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: var(--font-size-lg);\n  color: var(--color-text-tertiary);\n}\n\n.office-view-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--spacing-4);\n}\n\n.office-view-toggle {\n  display: flex;\n  background: var(--color-bg-primary);\n  border-radius: var(--radius-lg);\n  padding: var(--spacing-1);\n  box-shadow: var(--shadow-sm);\n}\n\n.office-view-toggle-btn {\n  padding: var(--spacing-2) var(--spacing-4);\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  color: var(--color-text-secondary);\n}\n\n.office-view-toggle-btn.office-active {\n  background:var(--color-primary);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.office-view-icon {\n  font-size: var(--font-size-lg);\n}\n\n.office-filter-and-sort {\n  display: flex;\n  gap: var(--spacing-3);\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.office-add-expense-btn, .office-show-all-btn {\n  background: var(--gradient-secondary);\n  color: white;\n  padding: var(--spacing-2) var(--spacing-5);\n  border-radius: var(--radius-md);\n  border: none;\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  transition: all var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n}\n\n.office-add-expense-btn:hover, .office-show-all-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.office-btn-icon {\n  font-size: var(--font-size-lg);\n  transition: transform var(--transition-normal);\n}\n\n.office-add-expense-btn:hover .office-btn-icon {\n  transform: rotate(90deg);\n}\n\n.office-show-all-btn:hover .office-btn-icon {\n  transform: rotate(360deg);\n}\n\n/* ========== Error State ========== */\n.office-office-error {\n  max-width: 1400px;\n  margin: 0 auto var(--spacing-8);\n  padding: var(--spacing-4);\n  background: linear-gradient(135deg, #fff5f5, #fed7d7);\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-4);\n  box-shadow: var(--shadow-sm);\n  animation: slideIn var(--transition-normal);\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.office-error-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n  background: var(--color-danger);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-xl);\n  font-weight: bold;\n}\n\n.office-error-content h4 {\n  margin: 0 0 var(--spacing-1);\n  color: var(--color-danger);\n  font-size: var(--font-size-lg);\n}\n\n.office-error-content p {\n  margin: 0;\n  color: #742a2a;\n}\n\n/* ========== Loading State ========== */\n.office-office-loading {\n  max-width: 1400px;\n  margin: var(--spacing-16) auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-6);\n}\n\n.office-loading-animation {\n  display: flex;\n  gap: var(--spacing-2);\n}\n\n.office-loading-circle {\n  width: 16px;\n  height: 16px;\n  border-radius: var(--radius-full);\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.office-loading-circle:nth-child(1) {\n  background-color: var(--color-primary);\n  animation-delay: -0.32s;\n}\n\n.office-loading-circle:nth-child(2) {\n  background-color: var(--color-secondary);\n  animation-delay: -0.16s;\n}\n\n.office-loading-circle:nth-child(3) {\n  background-color: var(--color-accent);\n  animation-delay: 0s;\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n\n.office-office-loading p {\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-lg);\n}\n\n/* ========== Card View ========== */\n.office-stationary-card-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: var(--spacing-6);\n  padding: 0 var(--spacing-4);\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.office-stationary-card {\n  background: var(--color-bg-primary);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-card);\n  transition: all var(--transition-normal);\n  position: relative;\n}\n\n.office-stationary-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 5px;\n  height: 100%;\n  background: var(--gradient-primary);\n}\n\n.office-stationary-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-card-hover);\n}\n\n.office-stationary-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-4) var(--spacing-6);\n  background: var(--color-bg-tertiary);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.office-stationary-price {\n  font-weight: 700;\n  color: var(--color-primary);\n  font-size: var(--font-size-md);\n}\n\n.office-stationary-card-body {\n  padding: var(--spacing-6);\n}\n\n.office-stationary-info {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-4);\n}\n\n.office-info-item {\n  display: flex;\n  justify-content: space-between;\n}\n\n.office-info-label {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.office-info-value {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n  font-weight: 500;\n}\n\n.office-stationary-card-actions {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1px;\n  background: var(--color-border);\n}\n\n.office-card-icon {\n  font-size: var(--font-size-lg);\n}\n\n/* ========== Table View ========== */\n.office-expense-table-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 var(--spacing-4);\n  overflow-x: auto;\n}\n\n.office-expense-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: var(--color-bg-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-card);\n  overflow: hidden;\n}\n\n.office-expense-table th, .office-expense-table td {\n  padding: var(--spacing-4);\n  text-align: left;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.office-expense-table th {\n  background: var(--color-bg-tertiary);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  transition: background var(--transition-fast);\n}\n\n.office-expense-table th:hover {\n  background: var(--color-bg-secondary);\n}\n\n.office-expense-table tr:last-child td {\n  border-bottom: none;\n}\n\n.office-expense-table td {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n}\n\n.office-expense-table tr:hover {\n  background: var(--color-bg-tertiary);\n}\n\n.office-amount-cell {\n  font-weight: 600;\n  color: var(--color-primary);\n}\n\n.office-action-cell {\n  display: flex;\n  gap: var(--spacing-2);\n  align-items: center;\n}\n\n.office-sort-icon {\n  font-size: var(--font-size-xs);\n  margin-left: var(--spacing-1);\n}\n\n.office-action-btn {\n  padding: var(--spacing-2) var(--spacing-4);\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n.office-edit-btn {\n   \n    border: 2px solid rgb(255, 174, 0);\n    color: #ff8600;\n    background: white;\n}\n\n.office-delete-btn {\n  background: var(--gradient-danger);\n  color: white;\n}\n\n.office-print-btn {\n  background: white;\n  color: rgb(0, 0, 0);\n  border: 2px solid black;\n}\n\n.office-action-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n/* ========== Pagination ========== */\n.office-pagination-container {\n  display: flex;\n  justify-content: center;\n  margin: var(--spacing-6) 0;\n}\n\n.office-pagination {\n  display: flex;\n  gap: var(--spacing-2);\n}\n\n.office-pagination-btn {\n  padding: var(--spacing-2) var(--spacing-4);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-primary);\n  color: var(--color-text-primary);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.office-pagination-btn:hover:not(:disabled) {\n  background: var(--color-bg-tertiary);\n  border-color: var(--color-text-tertiary);\n}\n\n.office-pagination-btn.office-active {\n  background:grey;\n  color: white;\n  border-color: transparent;\n}\n\n.office-pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ========== No Data State ========== */\n.office-office-no-data {\n  text-align: center;\n  padding: var(--spacing-16) var(--spacing-4);\n  background: var(--color-bg-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.office-no-data-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-4);\n}\n\n.office-no-data-icon {\n  font-size: var(--font-size-5xl);\n  color: var(--color-text-tertiary);\n  margin-bottom: var(--spacing-4);\n  animation: float 3s ease-in-out infinite;\n}\n\n.office-no-data-content h3 {\n  color: var(--color-text-primary);\n  font-size: var(--font-size-2xl);\n  margin-bottom: var(--spacing-2);\n}\n\n.office-no-data-content p {\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-md);\n  margin-bottom: var(--spacing-6);\n}\n\n.office-add-expense-btn-small {\n  background: var(--gradient-secondary);\n  color: white;\n  padding: var(--spacing-2) var(--spacing-4);\n  border-radius: var(--radius-md);\n  border: none;\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n}\n\n.office-add-expense-btn-small:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-sm);\n}\n\n/* ========== Add/Edit Form ========== */\n.office-addofficeExpenseform-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  backdrop-filter: blur(2px);\n}\n\n.office-addofficeExpenseform-container {\n  background-color: #fff;\n  padding: 2.5rem;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 520px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  position: relative;\n}\n\n.office-addofficeExpenseform-close-button {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background-color: #e74c3c;\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.office-addofficeExpenseform-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #333;\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.office-addofficeExpenseform-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.office-addofficeExpenseform-field {\n  display: flex;\n  flex-direction: column;\n}\n\n.office-addofficeExpenseform-input {\n  padding: 0.75rem 1rem;\n  border: 2px solid #ccc;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.3s, box-shadow 0.3s;\n}\n\n.office-addofficeExpenseform-input:focus {\n  border-color: #ff5e00;\n  box-shadow: 0 0 0 3px rgba(255, 115, 0, 0.2);\n  outline: none;\n}\n\n.office-addofficeExpenseform-submit-button {\n  background-color: #ff5100;\n  color: #fff;\n  border: none;\n  padding: 0.9rem;\n  border-radius: 10px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-top: 1rem;\n}\n\n.office-addofficeExpenseform-submit-button:hover {\n  background-color: #b33900;\n}\n\n/* ========== Date Range Wrapper ========== */\n.office-date-range-wrapper {\n  display: flex;\n  gap: var(--spacing-4);\n  margin-bottom: var(--spacing-6);\n  flex-wrap: wrap;\n}\n\n.office-date-input {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 150px;\n}\n\n.office-date-label {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-2);\n  font-weight: 500;\n}\n\n.office-office-search-input[type=\"date\"] {\n  padding: var(--spacing-3) var(--spacing-4);\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n/* ========== Total Amount Display ========== */\n.office-total-amount {\n  margin-bottom: var(--spacing-6);\n  text-align: center;\n}\n\n.office-total-amount h3 {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--color-primary);\n  background: var(--color-bg-primary);\n  padding: var(--spacing-2) var(--spacing-4);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n}\n\n/* ========== Responsive Adjustments ========== */\n@media (max-width: 1200px) {\n  .office-office-title {\n    font-size: var(--font-size-3xl);\n  }\n}\n\n@media (max-width: 992px) {\n  .office-view-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .office-view-toggle {\n    justify-content: center;\n  }\n\n  .office-filter-and-sort {\n    justify-content: space-between;\n  }\n}\n\n@media (max-width: 768px) {\n  .office-office-title {\n    font-size: var(--font-size-2xl);\n  }\n\n  .office-stationary-card-container {\n    grid-template-columns: 1fr;\n  }\n\n  .office-date-range-wrapper {\n    flex-direction: column;\n  }\n\n  .office-date-input {\n    min-width: 100%;\n  }\n\n  .office-expense-table th, .office-expense-table td {\n    padding: var(--spacing-3);\n    font-size: var(--font-size-xs);\n  }\n\n  .office-action-btn {\n    padding: var(--spacing-1) var(--spacing-2);\n    font-size: var(--font-size-xs);\n  }\n}\n\n@media (max-width: 576px) {\n  .office-office-header {\n    padding: var(--spacing-8) var(--spacing-4);\n  }\n\n  .office-filter-and-sort {\n    flex-direction: column;\n    gap: var(--spacing-2);\n  }\n\n  .office-add-expense-btn, .office-show-all-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .office-stationary-card-actions {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .office-addofficeExpenseform-container {\n    padding: 1.5rem;\n  }\n\n  .office-addofficeExpenseform-title {\n    font-size: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
